import React from 'react';
import './PoliceCar.css';

const CAR_IMG = process.env.PUBLIC_URL + '/granta.png';

function PoliceCar() {
  return (
    <div className="police-car-scene">
      {/* Дорога */}
      <div className="road">
        <div className="road-line" />
        <div className="road-line" />
        <div className="road-line" />
        <div className="road-line" />
        <div className="road-line" />
        <div className="road-line" />
        <div className="road-line" />
        <div className="road-line" />
      </div>

      <div className="police-car">
        {/* Мигалки — световая панель */}
        <div className="lightbar">
          <div className="lightbar-base" />
          <div className="lb-light red l1" />
          <div className="lb-light red l2" />
          <div className="lb-light white lc" />
          <div className="lb-light blue r1" />
          <div className="lb-light blue r2" />
        </div>

        {/* Лучи от мигалок */}
        <div className="siren-cone cone-red" />
        <div className="siren-cone cone-blue" />

        {/* PNG машины */}
        <img src={CAR_IMG} alt="Lada Granta Sport" className="car-image" draggable={false} />

{/* Луч фар */}
        <div className="hl-beam" />

        {/* Выхлоп */}
        <div className="exhaust-smoke">
          <div className="smoke-puff p1" />
          <div className="smoke-puff p2" />
          <div className="smoke-puff p3" />
          <div className="smoke-puff p4" />
        </div>

        {/* Тень */}
        <div className="car-ground-shadow" />
      </div>
    </div>
  );
}

export default PoliceCar;
